import axios from 'axios';

const instance = axios.create({
    baseURL: process.env.REACT_APP_API_URL || 'https://rr-admin.gala.biz',
    withCredentials: true,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    },
    maxRedirects: 5,
    timeout: 600000,  // 10분(600초)으로 설정
    validateStatus: function (status) {
        return status >= 200 && status < 500;
    }
});


console.log('API URL:', process.env.REACT_APP_API_URL);

export default instance;